import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "price", "total", "error", "submit"]
  static values = { centsPerLead: Number, currentBalance: Number }

  connect() {
    this.update()
  }

  update() {
    const quantity = Number.parseInt(this.inputTarget.value, 10)
    const valid = Number.isInteger(quantity) && quantity >= 100 && quantity % 10 === 0

    this.errorTarget.classList.toggle("hidden", valid)
    this.submitTarget.disabled = !valid
    this.submitTarget.classList.toggle("opacity-50", !valid)

    if (!valid) return

    const price = quantity * this.centsPerLeadValue / 100
    this.priceTarget.textContent = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD"
    }).format(price)
    this.totalTarget.textContent = `${(this.currentBalanceValue + quantity).toLocaleString()} total leads available after purchase`
  }
}
